// extracted by mini-css-extract-plugin
export default {"noData":"no-data-row_noData__XaQ8v"};